module.exports = __webpack_public_path__ + "static/media/mule-deer@2x.8909ce83.jpg";